import { Component, OnInit, AfterViewInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { SubLevelSliderComponent, SubLevel, SliderChangeData } from './../sub-level-slider/sub-level-slider.component';

export interface SubUpdateModalData {
	subLevelName?: string;
}

@Component({
	selector: 'app-modal-sub-update',
	templateUrl: './modal-sub-update.component.html',
	styleUrls: ['./modal-sub-update.component.css']
})
export class ModalSubUpdateComponent implements OnInit, AfterViewInit {

	@ViewChild('slider') sliderRef: SubLevelSliderComponent;
	// Current slider value
	public currValue: number;
	// Original slider value
	public originalValue: number;
	//
	private subLevel: SubLevel;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: SubUpdateModalData,
		public dialogRef: MatDialogRef<ModalSubUpdateComponent>
	) { }

	updateSlider(e: SliderChangeData) {
		if (e.level) {
			this.subLevel = e.level;
			this.currValue = this.subLevel.idx;
		}
	}
	close(isApply?) {
		if (isApply && this.currValue !== this.originalValue) { // Apply if the value is changed
			this.dialogRef.close(this.subLevel);
		} else { // Cancel
			this.dialogRef.close(false);
		}
	}
	ngOnInit() {

	}
	ngAfterViewInit() {
		// Store the initial value
		this.originalValue = this.sliderRef.getSliderValueByLevelValue(this.data.subLevelName);
		if (this.originalValue === -1) { // Level not found
			this.originalValue = 0; // Default 0
		}
		//
		this.currValue = this.originalValue;
	}

}



// WEBPACK FOOTER //
// ./src/app/components/portal/subscription-manage/modal-sub-update/modal-sub-update.component.ts